import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ZoomSupport.css';

const ZoomSupport = () => {
    const navigate = useNavigate();

    return (
        <div className="support-page">
            <div className="support-container">
                <div className="support-card">
                    <h1 className="support-title">ClientBloom Support</h1>
                    <p className="support-description">
                        For help integrating ClientBloom with Zoom and the platform:
                    </p>
                    
                    <div className="support-details">
                        <div className="support-item">
                            <strong>Email:</strong>
                            <a href="mailto:hello@clientbloom.ai" className="support-email">
                                hello@clientbloom.ai
                            </a>
                        </div>
                        
                        <div className="support-item">
                            <strong>Support hours:</strong>
                            <span>Monday–Friday, 9:00–17:00 (UTC)</span>
                        </div>

                        <div className="support-item">
                            <strong>Response time:</strong>
                            <span>1-2 business days</span>
                        </div>
                        
                        <div className="support-item">
                            <strong>Please include:</strong>
                            <ul className="support-requirements">
                                <li>Workspace Name</li>
                                <li>Zoom account email address</li>
                                <li>Meeting date and time (UTC)</li>
                                <li>Screenshots (if available)</li>
                            </ul>
                        </div>
                    </div>

                    <div className="knowledge-base-section">
                        <h2>Zoom Integration Knowledge Base</h2>
                        <p>Find detailed step-by-step guides and documentation:</p>
                        <button 
                            className="help-center-button"
                            onClick={() => navigate('/zoom-documentation')}
                        >
                            📚 Visit Help Center →
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ZoomSupport;
